import _ from "lodash"

export function createEditOrderStatusPayload(status) {
  return { status }
}

export function createEditOrderPayload(data) {
  const deliveryInfo = _.pick(data.deliveryInfo, [
    "pickupTime",
    "deliveryTime",
    "transportationTime",
    "carrier",
    "airWaybillUri",
    "sealBagBarcode",
  ])
  const parcel = _.pick(data.parcel, [
    "waybillDate",
    "trackingNo",
    "actualWeight",
    "actualShippingValueHKD",
    "insurer",
  ])
  const remark = data.remark

  return {
    deliveryInfo: {
      ...deliveryInfo,
    },
    parcel,
    remark,
  }
}

export function createGetOrderParams(status) {
  return { orderStatus: status }
}

export const rhetoricalOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
]
